import { render, staticRenderFns } from "./OrderReferences.vue?vue&type=template&id=06ae4c3a"
import script from "./OrderReferences.vue?vue&type=script&lang=js"
export * from "./OrderReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports